/* common imports */
import React from "react";

/* component imports */

/* @mui imports */

import { Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useRouter } from "next/router";

type CustomAttributesForDivElement = {
	index?: number;
};

/* stylings */

const SectionContainer = styled("div")<CustomAttributesForDivElement>(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	[theme.breakpoints.down("xsPlus")]: {
		display: "flex",
		flexDirection: "column",
		// padding: "3rem 1.2rem 3rem 1.2rem",
		// margin: "1.75rem 0rem 1rem 0rem",
	},
}));

const Heading = styled(Typography)(({ theme }) => ({
	display: "flex",
	color: theme.palette.primary.main,
	justifyContent: "flex-start",
	alignItems: "flex-start",
	fontWeight: 400,
	fontSize: "2rem",
	lineHeight: "3.1875rem",
	padding: "1rem 0rem 1rem 0rem",
	[theme.breakpoints.down("sm")]: {
		fontSize: "1.5rem",
		lineHeight: "2.25rem",
	},
}));

const SubHeading = styled(Typography)(({ theme }) => ({
	display: "flex",
	wordBreak: "break-word",
	padding: "1rem 0rem 1rem 0rem",
	width: "100%",
	color: theme.palette.mode == "dark" ? "#FFFFFF" : "#000000",
	fontWeight: "250",
	fontSize: "1.125rem",
	lineHeight: "1.75rem",
}));

const SectionOne = () => {
	const router = useRouter();

	const localLang = {
		heading:
			router.locale === "ar-AE"
				? "بيان سياسة الخصوصية"
				: router.locale === "kn-IN"
					? "ಗೌಪ್ಯತಾ ನೀತಿ ಹೇಳಿಕೆ"
					: "PRIVACY POLICY STATEMENT",
		subheading:
			router.locale === "ar-AE"
				? `الهدف من بيان سياسة الخصوصية هذا هو إعلامك بممارسات الشركة فيما يتعلق بجمع واستخدام والكشف ونقل المعلومات الشخصية التي تقدمها أو التي تقوم الشركة بجمعها من خلال استخدامك للمنصة الإلكترونية ("سياسة الخصوصية").`
				: router.locale === "kn-IN"
					? 'ಈ ಗೌಪ್ಯತಾ ನೀತಿ ಹೇಳಿಕೆಯ ಉದ್ದೇಶವು ಆನ್‌ಲೈನ್ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಬಳಕೆಯ ಮೂಲಕ ನೀವು ಒದಗಿಸಿದ ಅಥವಾ ಕಂಪನಿಯು ಸಂಗ್ರಹಿಸಿದ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯ ಸಂಗ್ರಹ, ಬಳಕೆ, ಬಹಿರಂಗಪಡಿಸುವಿಕೆ ಮತ್ತು ವರ್ಗಾವಣೆಯ ಸಂಬಂಧದಲ್ಲಿ ಕಂಪನಿಯ ಅಭ್ಯಾಸಗಳನ್ನು ನಿಮಗೆ ತಿಳಿಸಲು ಉದ್ದೇಶಿಸಲಾಗಿದೆ ("ಗೌಪ್ಯತಾ ನೀತಿ").'
					: "The aim of this privacy policy statement is to inform you regarding the company's practices in relation to the collection, use, disclosure, and transfer of personal information that is either provided by you or collected by the company through your use of the  online platform (“Privacy Policy”).",
	};

	return (
		<React.Fragment>
			<SectionContainer
				sx={{
					direction: router.locale === "ar-AE" ? "rtl" : "ltr",
				}}
			>
				<Heading>{localLang.heading}</Heading>
				<SubHeading>{localLang.subheading}</SubHeading>
			</SectionContainer>
		</React.Fragment>
	);
};
export default SectionOne;
